import React from 'react'
import PropTypes from 'prop-types'
import { Box, Button } from '@sainsburys-tech/fable'
import { SHORT_AVAILABILITY_MESSAGING } from '@/components/FulfilmentBox/availabilityMessages.js'

const AlternativeStore = ({ leadTimeKey, storeName, onSelectStore }) => {
  if (!leadTimeKey || !storeName) {
    return null
  }

  const alternativeStoreMessaging = SHORT_AVAILABILITY_MESSAGING[leadTimeKey] || 'Get it quicker'

  const leadTimeMessage = `Or ${alternativeStoreMessaging.toLowerCase()} at: `

  return (
    <Box className='ds-bg-blue-100 ds-rounded-[8px] ds-font-semibold ds-space-y-2' padding={{ sm: 'sm' }}>
      <span className='ds-text-blue'>
        {leadTimeMessage}
        <span className='ds-text-grey-900 ds-inline-block'>{storeName}</span>
      </span>
      <Button variant='secondary' isFullWidth onClick={onSelectStore} className='!ds-text-base'>
        Select Store
      </Button>
    </Box>
  )
}

AlternativeStore.propTypes = {
  leadTimeKey: PropTypes.string.isRequired,
  storeName: PropTypes.string.isRequired,
  onSelectStore: PropTypes.func.isRequired
}

export default AlternativeStore
